<template>
	<section class="section saved-searches">
		<div class="container mx-auto">

      <search-sort :modelValue="searchSortData" :sortMenu="sortMenu" placeholder="Search Seaches"></search-sort>

			<template v-if="!me">
				You must be signed in to see saved aletrs and searches
			</template>
			<template v-else-if="!saved_alerts">
				Loading...
			</template>
			<template v-else-if="computedFliteredSearches.length == 0">
				No searches / alerts found
			</template>
			<template v-else>

				<template v-for="(alert,a) in computedFliteredSearches" :key="a+'_'+alert.id">
          <div class="saved-searches-cards">
						<div class="saved-searches-card__outter">

							<input type="checkbox" :id="`saved-searches-checkbox_${a}`" class="saved-searches-card__checkbox">

							<div class="saved-searches-card__options">
								<div class="saved-searches-card__options-container">
									<div class="saved-searches-card__options-body">
										<div class="saved-searches-card__options-body-wrapper">
											<div class="saved-searches-card__options-body-btns">
												<block-saved-search-alert-btn :id="alert.id" class="btn btn-rounded btn-blue-light"></block-saved-search-alert-btn>
												<!-- <button :class="['btn btn-notification',{'active':alert.active}]" @click="toggleNotifications(alert.id)">
													<block-spinner :active="alert.id == spinnerId" size="5" :color="spinnerColor(alert)" class="absolute" :key="alert.id"></block-spinner>
													<p :class="[{'opacity-0':alert.id == spinnerId}]">{{ (alert.active) ? 'Turn off notifications' : 'Turn on notifications' }}</p>
												</button> -->
											</div>
										</div>
									</div>
									<label class="saved-searches-card__options-btn" :for="`saved-searches-checkbox_${a}`">
										<svg class="saved-searches-card__options-icon open" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.3 10.698L15 3.66l-.168-.838C14.467.698 11.299 0 11.299 0L9.617 1.564l-7.71 7.821L0 14.47.084 15l1.01-.084 4.57-1.871 2.635-2.347zm-3.393 1.676l-2.384.978-.112-.615-.224-.195-.505-.112.925-2.318s1.879.083 2.3 2.262z" fill="#fff"/></svg>
										<svg class="saved-searches-card__options-icon close" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="#fff"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M6 18L18 6M6 6l12 12"/></svg>
									</label>
								</div>
							</div>

							<div class="saved-searches-card">
								<div class="saved-searches-card__inner">

                  <div class="saved-searches-card__title-icon-container">
                    <svg class="saved-searches-card__title-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 15"><path d="M6.125 14.75c.957 0 1.75-.766 1.75-1.75h-3.5c0 .984.766 1.75 1.75 1.75zm5.879-4.074c-.52-.574-1.531-1.422-1.531-4.239 0-2.105-1.477-3.8-3.473-4.238v-.574A.9.9 0 006.125.75a.881.881 0 00-.875.875v.574c-2.023.438-3.5 2.133-3.5 4.239 0 2.816-1.012 3.664-1.531 4.238A.801.801 0 000 11.25c0 .465.355.875.875.875h10.473c.546 0 .875-.41.902-.875a.834.834 0 00-.246-.574z" fill="#162F47"/></svg>
                  </div>

                  <div class="saved-searches-card__inner-body">
                    <h5 class="saved-searches-card__title">
                      {{ alert.title }}
                    </h5>

                    <div class="saved-searches-card__inner-group">
                      <!-- <block-toggle-btn label="Job alert" :state="alert.active" @click.prevent="toggleNotifications(alert.id)"></block-toggle-btn> -->
                      <a class="btn btn-rounded btn-blue-light" :href="calculated_alert_link(alert)">View</a>
                    </div>
                  </div>

								</div>
							</div>

						</div>
					</div>
				</template>
			</template>
		</div>
	</section>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';
  import SearchSort from './partials/SearchSort';

	export default {
		name: 'SavedSearchesAlerts',

    mixins: [AuthMixins],

    components: {
      SearchSort
    },

    data() {
    	return  {
    		saved_alerts: false,
        spinnerId: null,
        searchSortData: {search:'', sort:'title_asc'},
        sortMenu: [
          { title: 'Title Ascending', value: 'title_asc', selected: false },
          { title: 'Title Descending', value: 'title_desc', selected: false }
        ]
    	}
    },

		created() {
			// this.emitter.on('close:saved-search-alerts', this.doClose);
		},
		beforeUnmount() {
			// this.emitter.off('close:saved-search-alerts', this.doClose);
		},

    mounted() {
      // console.log('saved_alerts', this.saved_alerts);
    },

    methods: {
    	calculated_alert_link(alert) {
    		let query;
    		let job_alert_id = alert.id;
    		if (alert['org-main-id'] !== "") {
    			query = encodeURI("query="+alert['org-name']);
    		} else {
    			query = alert['query'];
    		}
    		return '/search/jobs?q='+query+'&a='+job_alert_id;
    	},
    	toggleNotifications(job_alert_id) {
        if(this.spinnerId == null) {
          this.spinnerId = job_alert_id;
          let payload = {'job_alert_id':job_alert_id};
          return this.$api.toggleJobAlertNotifications(payload).then(
            (response) => {
              if (response.data.status == 'success') {
                this.emitter.emit("refresh:user");
                this.spinnerId = null;
              }
            }
          ).catch((response) => {
            console.log("Could not modify alert notifications.", response);
          });
        }
    	},
			doClose(job_alert_id) {
				this.$nextTick(() => {
					this.$refs[job_alert_id].checked = false;
				});
			},
			spinnerColor(alert) {
				return alert.active ? 'text-white' : 'text-blue-light';
			},
      refreshFilters() {
        switch (this.searchSortData.sort) {
          case 'title_asc':
          this.saved_alerts.sort((a, b) => a['title'].toLowerCase().localeCompare(b['title'].toLowerCase()));
            break;
          case 'title_desc':
          this.saved_alerts.sort((a, b) => b['title'].toLowerCase().localeCompare(a['title'].toLowerCase()));
            break;
        }
      }
    },

		computed: {
			computedFliteredSearches() {
        return this.saved_alerts.filter(v => {
          return v['title'].toLowerCase().includes(this.searchSortData.search.toLowerCase());
        });
      }
    },

    watch: {
    	me() {
    		// console.log("Identified a change to ME on the saved searches alerts component");
    		this.saved_alerts = (this.$store.getters.getUser['saved-alerts'] !== undefined) ? this.$store.getters.getUser['saved-alerts'] : false;
				if (this.saved_alerts) {
					this.saved_alerts = this.saved_alerts.filter(alert => alert.type !== 'personalised');
				}
    	},
      searchSortData: {
        deep:true,
        handler() {
          this.refreshFilters();
        }
      }
    }
	}
</script>
